<template>
  <div>
    <dialog-view
        :open="open"
        title="Снять с личного счета"
        @cancel="complete()"
        :hideCancelAction="payState.isLoading ? true : undefined"
        :cancelNotClose="true"
        content-full-size
        width="540"
    >
      <template v-slot:content>
        <div v-if="payState.isInit">
          <div class="mx-4 my-2">
            <v-row>
              <v-col>
                <div class="mb-1 body-2">Сумма</div>
                <div class="text-h5">{{$tools.price(amountPayed)}}</div>
              </v-col>
            </v-row>
          </div>
          <v-divider/>
          <div class="mx-4 mt-2 mb-4">
            <div class="mb-3 body-2">Передано</div>
            <v-form ref="form">
              <alert-view v-if="!$tools.isEmpty(devicesError)" :text="devicesError+'\n Расчет наличными и банковской картой недоступны'" icon="mdi-information-outline"/>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                      v-model="amountCash"
                      :disabled="!$tools.isEmpty(amountInsur)"
                      label="Наличными"
                      outlined dense hide-details="auto" class="big" clearable>
                    <template v-slot:label>
                      <v-icon small class="mr-2">mdi-cash</v-icon>Наличными
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12 mx-n4">
                  <v-divider style="width:calc(100% + 32px);max-width:calc(100% + 32px)"/>
                </v-col>
                <v-col cols="12" class="py-0">
                  <div class="mb-2 body-2">Передано организации</div>
                </v-col>
                <v-col cols="4" class="pt-0">
                  <v-text-field
                      v-model="amountInsur"
                      :disabled="!$tools.isEmpty(amountCash)"
                      outlined dense hide-details="auto" class="big" clearable
                  >
                    <template v-slot:label>
                      Сумма
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="8" class="pt-0">
                  <insur-select single @selected="(v)=>insurId=v.id"/>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <v-divider/>
          <div class="mx-4 my-4">
            <v-textarea v-model="comment" label="Комментарий к платежу" outlined dense hide-details auto-grow rows="2" clearable/>
          </div>
          <div class="mx-4 my-2">
            <div>Услуги</div>
            <v-btn block depressed @click="servicesOpen=true" class="mt-2">Добавить из прайс листа</v-btn>
            <visit-service-add
                :open.sync="servicesOpen"
                @complete="(v)=>services=v.filter(v1=>v1._count=1)"
                class="mb-2"
            />
            <v-sheet v-if="services.length>0" outlined rounded class="overflow-hidden">
              <alert>Услуги будут указаны в чеке и в комментарии к платежу</alert>
              <v-list dense class="pa-0">
                <div v-for="(v, i) in services" :key="i">
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-row no-gutters>
                        <v-col>
                          <v-list-item-title class="text-wrap">{{v.name}}</v-list-item-title>
                          <v-list-item-subtitle>{{$tools.price(v.price)}}</v-list-item-subtitle>
                        </v-col>
                        <v-col cols="auto">
                          <v-sheet width="100" class="mr-2">
                            <v-text-field
                                label="Скидка Р"
                                v-model="v._discount"
                                type="number"
                                min="1"
                                background-color="white" hide-details outlined dense
                            />
                          </v-sheet>
                        </v-col>
                        <v-col cols="auto">
                          <v-sheet width="60">
                            <v-text-field
                                label="Кол."
                                v-model="v._count"
                                type="number"
                                min="1"
                                background-color="white" hide-details outlined dense
                            />
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn @click="services=services.filter(v1=>v1.id!==v.id)" icon class="mt-n2"><v-icon>mdi-close</v-icon></v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="i<services.length-1"/>
                </div>
              </v-list>
            </v-sheet>
          </div>
          <v-divider/>
          <div class="mx-4 mt-2 mb-4">
            <div class="mb-3 body-2">Кассовое оборудование</div>
            <v-row no-gutters>
              <v-col class="pr-2">
                <v-select
                    label="Фискальный регистратор"
                    v-model="cashBox"
                    :items="cashBoxes"
                    outlined dense hide-details
                    item-text="name" item-value="id"
                    return-object
                >
                  <template v-slot:selection="{item}">
                    <div class="my-2">
                      <div class="body-2 font-weight-medium">{{item.name}}</div>
                    </div>
                  </template>
                  <template v-slot:item="{item}">
                    <div class="my-2">
                      <div class="body-2 font-weight-medium">{{item.name}}</div>
                    </div>
                  </template>
                </v-select>
              </v-col>
              <v-col class="pl-2">
                <v-select
                    label="Эквайринговый терминал"
                    v-model="terminal"
                    :items="terminals"
                    outlined dense hide-details item-text="name" item-value="id"
                    return-object
                >
                  <template v-slot:selection="{item}">
                    <div class="my-2">
                      <div class="body-2 font-weight-medium">{{item.name}}</div>
                    </div>
                  </template>
                  <template v-slot:item="{item}">
                    <div class="my-2">
                      <div class="body-2 font-weight-medium">{{item.name}}</div>
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </div>
          <v-divider/>
          <div class="mx-4 my-4">
            <v-btn @click="pay()" block depressed color="primary" :disabled="amountPayed===0">Снять</v-btn>
          </div>
        </div>
        <div v-if="payState.isLoading">
          <div v-if="payState.step===0" class="pb-4">
            <progress-page icon="mdi-account"/>
            <div class="text-center mt-n4">Сбор информации о кассире</div>
          </div>
          <div v-if="payState.step===1" class="pb-4">
            <progress-page icon="mdi-credit-card-outline"/>
            <div class="text-center mt-n4">Производиться оплата банковской картой<br/>через "{{terminal.name}}"</div>
          </div>
          <div v-if="payState.step===2" class="pb-4">
            <progress-page icon="mdi-cash-register"/>
            <div class="text-center mt-n4">Производиться регистрация платежа<br/>через "{{cashBox.name}}"</div>
          </div>
          <div v-if="payState.step===3" class="pb-4">
            <progress-page icon="mdi-content-save"/>
            <div class="text-center mt-n4">Сохранение платежа</div>
          </div>
        </div>
        <div v-if="payState.isSuccess" class="pb-4">
          <v-sheet class="position-relative d-flex align-center ma-auto" :width="96" :height="96" color="transparent">
            <v-icon class="position-absolute d-block mx-auto" style="margin-left:calc(50% - 27px)!important" color="success" size="54">mdi-check-circle</v-icon>
          </v-sheet>
          <div class="text-center mt-n4">Платеж успешно выполнен</div>
          <div class="mx-4 mt-4">
            <v-btn @click="complete()" block depressed color="primary">OK</v-btn>
          </div>
        </div>
        <div v-if="payState.isError">
          <div class="pb-4">
            <progress-page v-if="payState.step===0" icon="mdi-account" :loading="false"/>
            <progress-page v-if="payState.step===2" icon="mdi-cash-register" :loading="false"/>
            <progress-page v-if="payState.step===3" icon="mdi-content-save" :loading="false"/>
            <div class="text-center mt-n4 px-4">
              <div v-html="payState.errorMessage"></div>
            </div>
            <div class="text-center mt-2">
              <v-btn v-if="payState.step===0" @click="userLoad(userLoad_args[0])" small depressed>
                <v-icon class="mr-2" dense>mdi-refresh</v-icon>
                Повторить
              </v-btn>
              <v-btn v-if="payState.step===2"
                     @click="payRegister(payRegister_args[0],payRegister_args[1],payRegister_args[2])" small depressed>
                <v-icon class="mr-2" dense>mdi-refresh</v-icon>
                Повторить
              </v-btn>
              <v-btn v-if="payState.step===3" @click="payCreate(payCreate_args[0],payCreate_args[1],payCreate_args[2])"
                     small depressed>
                <v-icon class="mr-2" dense>mdi-refresh</v-icon>
                Повторить
              </v-btn>
            </div>
          </div>
        </div>
      </template>
    </dialog-view>
  </div>

</template>

<script>
import DialogView from "@/components/DialogView";
import Kkm from "@/Kkm";
import State from "@/plugins/state";
import ProgressPage from "@/components/ProgressPage.vue";
import axios from "axios";
import Api from "@/Api";
import AlertView from "@/components/AlertView.vue";
import InsurSelect from "@/views/Insur/components/InsurSelect.vue";
import Alert from "@/componentsV2/base/Alert.vue";
import VisitServiceAdd from "@/views/Visit/VisitServiceAdd.vue";

export default {
  components: {VisitServiceAdd, Alert, InsurSelect, AlertView, ProgressPage, DialogView},
  props:['open', 'userId', 'visitServices'],
  data: () => ({
    amountCash:null,
    amountInsur:null,
    insurId:null,
    comment:null,

    servicesOpen:false,
    services:[],

    kkm: new Kkm(),
    devicesError:null,
    cashBoxes:[],
    cashBox:null,
    terminals:[],
    terminal:null,

    payState: new State(),

    userLoad_args: null,
    payRegister_args: null,
    payCreate_args: null,
    payCreate_rid: null,
  }),
  watch:{
    open(){
      if(this.open) {
        this.amountCash = null;
        this.amountInsur = null;
        this.comment = null;
        this.services = [];
        this.payCreate_rid = null;

        this.devicesError = null;
        this.cashBoxes = [];
        this.cashBox = null;
        this.terminals = [];
        this.terminal = null;
        this.kkm.devices((res)=>{
          this.cashBoxes = res.filter(v=>v.typeName==='Фискальный регистратор');
          this.cashBox = this.$tools.storageGet('pay_fiscalReg', this.cashBoxes[0]);

          this.terminals = res.filter(v=>v.typeName==='Эквайринговый терминал');
          this.terminal = this.$tools.storageGet('pay_terminal', this.terminals[0]);

          this.cashBoxes.forEach(v1=>{
            this.kkm.deviceStatusSessionError(v1, (res)=>{
              if(res!==null)
                this.devicesError = res+' "'+v1.name+'"';
            }, e=>{
              this.devicesError = e+' "'+v1.name+'"';
            });
          });
        }, e=>{
          this.devicesError = e;
        });

        this.payState.stateInit();
      }
    },
    cashBox(v){
      this.$tools.storageSet('pay_fiscalReg', v)
    },
    terminal(v){
      this.$tools.storageSet('pay_terminal', v)
    },
    'amountCash'(str) {
      this.amountCash = this.$tools.priceFormatter(str);
    },
    'amountInsur'(str) {
      this.amountInsur = this.$tools.priceFormatter(str);
    },
    services: {
      deep: true,
      handler() {
        if (!this.$tools.isEmpty(this.comment)) {
          let arr = this.comment.split('\nУслуги:\n');
          this.comment = arr.length > 0 ? arr[0] : '';
          arr = this.comment.split('Услуги:\n');
          this.comment = arr.length > 0 ? arr[0] : '';
        }
        if (this.services.length > 0) {
          this.comment = this.$tools.isEmpty(this.comment) ? 'Услуги:\n' : this.comment + '\nУслуги:\n';
          this.services.forEach(v=>{
            this.comment += v.name+
                ' (количество: '+v._count+''+(this.$tools.parseNumber(v._discount)>0 ? ',скидка:'+this.$tools.price(v._discount) : '')+'):'+
                (this.$tools.price((v.price*v._count)-this.$tools.parseNumber(v._discount)))
                +'\n';
          });
        }
      }
    }
  },
  computed:{
    amountPayed(){
      let v = 0;
      v += this.$tools.parseNumber(this.amountCash);
      v += this.insurId==null ? 0 : this.$tools.parseNumber(this.amountInsur);
      return v;
    }
  },
  methods: {
    userLoad(success) {
      this.userLoad_args = [success];
      this.payState.stateLoading();
      this.payState.step = 0;

      axios.get(Api.host+'/user/status/')
          .then((res)=> {
            axios.get(Api.host + '/user/' + res.data.id + '/')
                .then((res) => {
                  success(res);
                })
                .catch(() => {
                  let v = 'Сбор информации о кассире: Не удалось получить информацию';
                  this.payState.stateError(v);
                  this.$store.commit('alertError', v);
                });
          })
          .catch(() => {
            let v = 'Сбор информации о кассире: Не удалось получить информацию';
            this.payState.stateError(v);
            this.$store.commit('alertError', v);
          });
    },

    payRegister(userRes, items, success) {
      this.payRegister_args = [userRes, items, success];
      this.payState.stateLoading();
      this.payState.step = 2;

      this.kkm.payRegisterCancel(
          this.cashBox,
          userRes.data.lastName + ' ' + userRes.data.firstName,
          userRes.data.userProfile.inn,
          this.$tools.parseNumber(this.amountCash),
          0,
          items,
          () => {
            success();
          }, e => {
            let v = 'Фискальный регистратор: ' + e;
            this.payState.stateError(v);
            this.$store.commit('alertError', v);
          });
    },

    payCreate(cashBox = null, terminal = null, success) {
      this.payCreate_args = [cashBox, terminal, success];
      this.payState.stateLoading();
      this.payState.step = 3;

      if(this.payCreate_rid===null)
        this.payCreate_rid = this.$tools.token();

      let data = {
        rid: this.payCreate_rid,
        type:'accountOut',
        userId:this.userId,
        comment:this.comment,
      };
      if(this.$tools.parseNumber(this.amountCash)>0) data.amountCash = this.$tools.parseNumber(this.amountCash);
      if(this.$tools.parseNumber(this.amountInsur)>0 && this.insurId!=null){
        data.amountInsur = this.$tools.parseNumber(this.amountInsur);
        data.insurId = this.insurId;
      }

      if(cashBox!==null)
        data.kktName=cashBox.name;
      if(terminal!==null)
        data.terminalName=terminal.name;

      axios.post(Api.host+'/pay/pay/', data)
          .then(()=> {
            this.payCreate_rid = null;
            success();
          }).catch((e)=>{
        if(e.response?.status===409) {
          this.payCreate_rid = null;
          success();
        } else {
          let v = 'Сохранение операции в МИС: ' + (e.response?.data?.message ?? 'Не удалось подключиться');
          this.payState.stateError(v);
          this.$store.commit('alertError', v);
        }
      });
    },

    pay(){
      if(this.services.length>0){
        let s = 0;
        this.services.forEach(v=>
            s+= (this.$tools.parseNumber(v.price)*this.$tools.parseNumber(v._count))-
                this.$tools.parseNumber(v._discount)
        )
        if(this.$tools.parseNumber(this.amountPayed)!==s) {
          this.$store.commit('alertError', 'Сумма выбранных услуг не совпадает с указанной суммой');
          return null;
        }
      }

      if (this.$refs.form.validate()) {

        if(this.$tools.parseNumber(this.amountInsur)>0 && this.insurId!=null){
          this.payState.stateLoading();
          this.payCreate(null, null, () => {
            this.payState.stateSuccess();
          });
          return null;
        }

        let arr = [{
          name: 'Аванс',
          count: 1,
          price: this.amountPayed,
          priceTotal: this.amountPayed,
          tax: -1,
          type: 'service'//'prepaid'
        }];

        if(this.services.length>0){
          arr = [];
          this.services.forEach(v=> {
            arr.push({
              name: v.name,
              count: v._count,
              price: this.$tools.parseNumber(v.price),
              priceTotal: (this.$tools.parseNumber(v.price)*v._count)-this.$tools.parseNumber(v._discount),
              tax: -1,
              type: 'service'//'prepaid'
            });
          });
        }

        this.payState.stateLoading();

        this.userLoad((userRes) => {
          this.payRegister(userRes, arr, () => {
            this.payCreate(this.cashBox, null, () => {
              this.payState.stateSuccess();
            });
          });
        });
      }
    },
    complete(){
      if (!this.payState.isLoading)
        this.$emit('complete');
    }
  }
}
</script>
